import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😴',
  text: 'Te acuestas agotado pero no puedes dormir'
}, {
  emoji: '🫃',
  text: 'Tienes grasa abdominal que no baja aunque hagas dieta'
}, {
  emoji: '🧠',
  text: 'Tu mente no para y la ansiedad te consume'
}, {
  emoji: '☕',
  text: 'Necesitas café para funcionar cada mañana'
}, {
  emoji: '😤',
  text: 'Te irritas fácilmente por cosas pequeñas'
}, {
  emoji: '🔁',
  text: 'Sientes que tu cuerpo trabaja en tu contra'
}];
export const ProblemSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-lightmint" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-114">
            ¿Te identificas con alguna de estas situaciones?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-115">
          {painPoints.map((point, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-116">
              <span className="text-4xl" data-id="element-117">{point.emoji}</span>
              <p className="font-bold text-brand-charcoal text-lg leading-snug" data-id="element-118">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.6
      }} data-id="element-119">
          <p className="text-2xl md:text-3xl font-bold text-brand-emerald" data-id="element-120">
            Si dijiste sí a 2 o más... tu cortisol está elevado.
          </p>
        </motion.div>
      </div>
    </section>;
};